var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "stats-cards" }, [
      _c(
        "div",
        {
          staticClass: "stats-card customer-following",
          on: {
            click: function ($event) {
              return _vm.goToCustomers("跟进中")
            },
          },
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.customerStats.following)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("跟进中")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card customer-noOrder",
          on: {
            click: function ($event) {
              return _vm.goToCustomers("未下单")
            },
          },
        },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.customerStats.noOrder)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("未下单")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card customer-ordered",
          on: {
            click: function ($event) {
              return _vm.goToCustomers("已下单")
            },
          },
        },
        [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.customerStats.ordered)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("已下单")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card customer-todayPlan",
          on: {
            click: function ($event) {
              return _vm.goToCustomers("今日测量")
            },
          },
        },
        [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.customerStats.todayPlanNum)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("今日测量")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card customer-tomorrowPlan",
          on: {
            click: function ($event) {
              return _vm.goToCustomers("明日测量")
            },
          },
        },
        [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.customerStats.tomorrowPlanNum)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("明日测量")]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _c("div", { staticClass: "stats-cards" }, [
      _c(
        "div",
        {
          staticClass: "stats-card modifySupplement-pending",
          staticStyle: { flex: "none", width: "280px" },
          on: { click: _vm.goToModifySupplement },
        },
        [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.modifySupplementStats.pending)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待处理订单")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card modifySupplement-assign",
          staticStyle: { flex: "none", width: "280px" },
          on: { click: _vm.goToModifySupplementAssign },
        },
        [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.modifySupplementStats.assign)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("指派处理订单")]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm._m(9),
    _vm._v(" "),
    _c("div", { staticClass: "stats-cards" }, [
      _c(
        "div",
        {
          staticClass: "stats-card contract-pendingSign",
          on: {
            click: function ($event) {
              return _vm.goToContracts("待签单")
            },
          },
        },
        [
          _vm._m(10),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.pendingSign)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待签单")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card contract-signed",
          on: {
            click: function ($event) {
              return _vm.goToContracts("已签单")
            },
          },
        },
        [
          _vm._m(11),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.signed)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("已签单")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card contract-pendingDesign",
          on: {
            click: function ($event) {
              return _vm.goToContracts("待确认设计方案")
            },
          },
        },
        [
          _vm._m(12),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.pendingDesign)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [
              _vm._v("待确认设计方案"),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card contract-pendingOrder",
          on: {
            click: function ($event) {
              return _vm.goToContracts("待下单")
            },
          },
        },
        [
          _vm._m(13),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.pendingOrder)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待下单")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card contract-pendingAudit",
          on: {
            click: function ($event) {
              return _vm.goToContracts("待审计")
            },
          },
        },
        [
          _vm._m(14),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.pendingAudit)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待审计")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card contract-splitAudit",
          on: {
            click: function ($event) {
              return _vm.goToContracts("待拆单审核")
            },
          },
        },
        [
          _vm._m(15),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.splitAudit)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待拆单审核")]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "stats-cards" }, [
      _c(
        "div",
        {
          staticClass: "stats-card contract-quoteAudit",
          on: {
            click: function ($event) {
              return _vm.goToContracts("待报价审核")
            },
          },
        },
        [
          _vm._m(16),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.quoteAudit)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待报价审核")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card contract-dealerConfirm",
          on: {
            click: function ($event) {
              return _vm.goToContracts("待经销商确认")
            },
          },
        },
        [
          _vm._m(17),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.dealerConfirm)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待经销商确认")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card contract-financeAudit",
          on: {
            click: function ($event) {
              return _vm.goToContracts("待财务审核")
            },
          },
        },
        [
          _vm._m(18),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.financeAudit)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待财务审核")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card contract-partialIn",
          on: {
            click: function ($event) {
              return _vm.goToContracts("部分入库")
            },
          },
        },
        [
          _vm._m(19),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.partialIn)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("部分入库")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card contract-fullyIn",
          on: {
            click: function ($event) {
              return _vm.goToContracts("全部入库")
            },
          },
        },
        [
          _vm._m(20),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.contractStats.fullyIn)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("全部入库")]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm._m(21),
    _vm._v(" "),
    _c("div", { staticClass: "stats-cards" }, [
      _c(
        "div",
        {
          staticClass: "stats-card total",
          on: {
            click: function ($event) {
              return _vm.goToOrders("")
            },
          },
        },
        [
          _vm._m(22),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.orderStats.total)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("订单总数")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card pending",
          on: {
            click: function ($event) {
              return _vm.goToOrders("未提交")
            },
          },
        },
        [
          _vm._m(23),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.orderStats.pending)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("未提交")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card unpaid",
          on: {
            click: function ($event) {
              return _vm.goToOrders("待经销商确认")
            },
          },
        },
        [
          _vm._m(24),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.orderStats.unpaid)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待经销商确认")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card inbound",
          on: {
            click: function ($event) {
              return _vm.goToOrders("待报价审核")
            },
          },
        },
        [
          _vm._m(25),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.orderStats.inbound)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待报价审核")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card instocked",
          on: {
            click: function ($event) {
              return _vm.goToOrders("全部入库")
            },
          },
        },
        [
          _vm._m(26),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.orderStats.instocked)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("全部入库")]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm._m(27),
    _vm._v(" "),
    _c("div", { staticClass: "stats-cards" }, [
      _c(
        "div",
        {
          staticClass: "stats-card delivery-total",
          on: {
            click: function ($event) {
              return _vm.goToDelivery("")
            },
          },
        },
        [
          _vm._m(28),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.deliveryStats.total)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("全部")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card delivery-pendingAppointment",
          on: {
            click: function ($event) {
              return _vm.goToDelivery("待预约")
            },
          },
        },
        [
          _vm._m(29),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.deliveryStats.pendingAppointment)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待预约")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card delivery-pendingDelivery",
          on: {
            click: function ($event) {
              return _vm.goToDelivery("待送货")
            },
          },
        },
        [
          _vm._m(30),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.deliveryStats.pendingDelivery)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待送货")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card delivery-pendingReceipt",
          on: {
            click: function ($event) {
              return _vm.goToDelivery("待送达")
            },
          },
        },
        [
          _vm._m(31),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.deliveryStats.pendingReceipt)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待送达")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card delivery-completed",
          on: {
            click: function ($event) {
              return _vm.goToDelivery("完成")
            },
          },
        },
        [
          _vm._m(32),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.deliveryStats.completed)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("完成")]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "section-title",
        on: {
          click: function ($event) {
            return _vm.goToInstallation("")
          },
        },
      },
      [
        _c("i", { staticClass: "el-icon-s-home" }),
        _vm._v(" "),
        _c("span", [_vm._v("安装管理")]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "stats-cards" }, [
      _c(
        "div",
        {
          staticClass: "stats-card install-total",
          on: {
            click: function ($event) {
              return _vm.goToInstallation("")
            },
          },
        },
        [
          _vm._m(33),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.installationStats.total)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("全部")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card install-pendingSubmit",
          on: {
            click: function ($event) {
              return _vm.goToInstallation("待提交")
            },
          },
        },
        [
          _vm._m(34),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.installationStats.pendingSubmit)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待提交")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card install-pendingInstall",
          on: {
            click: function ($event) {
              return _vm.goToInstallation("待安装")
            },
          },
        },
        [
          _vm._m(35),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.installationStats.pendingInstall)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("待安装")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card install-installing",
          on: {
            click: function ($event) {
              return _vm.goToInstallation("安装中")
            },
          },
        },
        [
          _vm._m(36),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.installationStats.installing)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("安装中")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "stats-card install-completed",
          on: {
            click: function ($event) {
              return _vm.goToInstallation("完成")
            },
          },
        },
        [
          _vm._m(37),
          _vm._v(" "),
          _c("div", { staticClass: "stats-content" }, [
            _c("div", { staticClass: "stats-number" }, [
              _vm._v(_vm._s(_vm.installationStats.completed)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-label" }, [_vm._v("完成")]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("i", { staticClass: "el-icon-s-custom" }),
      _vm._v(" "),
      _c("span", [_vm._v("客户管理")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-marketing" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-order" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-shop" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-date" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-date" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("i", { staticClass: "el-icon-refresh" }),
      _vm._v(" "),
      _c("span", [_vm._v("改补管理")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-refresh" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-user" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("i", { staticClass: "el-icon-document" }),
      _vm._v(" "),
      _c("span", [_vm._v("合同管理")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-edit-outline" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-edit" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-operation" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-order" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-share" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-goods" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-custom" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-finance" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-grid" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-check" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("i", { staticClass: "el-icon-s-order" }),
      _vm._v(" "),
      _c("span", [_vm._v("订单管理")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-tickets" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-time" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-wallet" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-box" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-check" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("i", { staticClass: "el-icon-truck" }),
      _vm._v(" "),
      _c("span", [_vm._v("发货管理")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-tickets" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-date" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-truck" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-check" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-tickets" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-date" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-claim" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-s-operation" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-icon" }, [
      _c("i", { staticClass: "el-icon-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }